'use client';

import Image from 'next/image';
import classNames from 'classnames';

export default function PoweredBySerefin({
  className,
  display = 'desktopOnly',
  isWhite = false,
}: {
  isWhite?: boolean;
  display?: 'desktopOnly' | 'mobileOnly' | 'all';
  className?: string;
}) {
  const src = `/poweredBySerefin${isWhite ? 'White' : ''}.png`;

  const visibilityClass =
    display === 'desktopOnly'
      ? 'block max-sm:hidden'
      : display === 'mobileOnly'
        ? 'mt-4 hidden self-center max-sm:flex sm:hidden'
        : '';

  return (
    <Image
      src={src}
      width={220}
      height={40}
      alt="Powered by Serefin"
      className={classNames(visibilityClass, className)}
      sizes="220px"
      placeholder="blur"
      blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
    />
  );
}
